module.exports = __webpack_public_path__ + "static/media/background-payment.0a12caed.png";